// ----------------------------------------------------------------------

/**
 * Färg per notifieringsdomän. Ikonen kommer från backend (NotifieringsTyp.ikon), men färgen
 * hör till gränssnittet — den ska följa temat och inte lagras i databasen.
 *
 * Domännamnen är konstanterna i NotifieringsTyp.Domän. En domän som saknas här faller tillbaka
 * på 'primary', så en ny domän i backend ger en fungerande rad direkt.
 */
const DOMÄNFÄRG: Record<string, 'primary' | 'info' | 'success' | 'warning' | 'error' | 'secondary'> =
  {
    HEM: 'info',
    ÄRENDE: 'warning',
    UTLÅNINGSPOOL: 'secondary',
    EKONOMI: 'success',
    MYNDIGHET: 'primary',
    // Integrationsnotifieringar handlar uteslutande om att något slutat fungera.
    INTEGRATION: 'error',
    ORGANISATION: 'info',
    UTSKICK: 'secondary',
    STYRELSE: 'primary',
    FASTIGHET: 'warning',
    DOKUMENT: 'info',
    SYSTEM: 'secondary',
  };

export function färgFörDomän(domän: string) {
  return DOMÄNFÄRG[domän] ?? 'primary';
}
